import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  Text,
  ModalBody,
  Button,
  VStack,
  Image,
} from "@chakra-ui/react";
import { useUser } from "../hooks/useUser";
import { useNavigate } from "react-router-dom";

export function ModalSubscriptionEnded() {
  const navigate = useNavigate();
  const { data } = useUser();

  const { isOpen, onClose } = useDisclosure({
    isOpen: data && !data?.activeSubscription,
    onClose: () => {},
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalBody textAlign="center">
          <VStack spacing="8" p="8">
            <Image
              src={"https://storage.googleapis.com/roadroamer/logo.png"}
              alt="logo"
            />
            <Text fontSize={64}>😞</Text>
            <Text as="b" fontSize="xl" color="green">
              Votre période d'essai est terminée...
            </Text>
            <Text>
              Découvrez maintenant nos abonnements pour profiter de Road Roamer
              en illimité !
            </Text>
            <Button variant="primary" onClick={() => navigate("/subscription")}>
              Continuer
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
